export default "https://cdn-static.gokick.com/assets/81b7a47639310ad105c767144326fc68b25cbb5d/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";